import { Box } from "@chakra-ui/layout";
import React, { FC, memo } from "react";
import ProductItem from "./DropDownProductItem";

interface IProps {
  item: {
    description: string;
    imgage: string;
    name: string;
    slug: string;
    target_label: string;
  };
}

const DropListItem: FC<IProps> = ({ item }) => {
  return (
    <Box mb={"1.625rem"}>
      <ProductItem h={"7.15rem"} product={item} />
    </Box>
  );
};

export default memo(DropListItem);
